export default "__VITE_ASSET__DRhJ1fEP__"